// extracted by mini-css-extract-plugin
export var debugInfo = "DebugInfo-module--debugInfo--x-3hF";